// extracted by mini-css-extract-plugin
export default {"background":"AuthComponent_background__Ssnmf","loading":"AuthComponent_loading__damNG","authButton":"AuthComponent_authButton__lE4Uw"};